import React from 'react';

import {
  useConfirmCodeActivityLazyQuery,
  useConfirmCodeActivity_SaveSiteUserMutation
} from 'generated/graphql';
import {
  authService,
  useLoading
} from 'modules';



export interface ITuple {
  loading: boolean;
}



export function useConfirmCodeActivity() {
  const [confirmCode, confirmCodeTuple] = __useConfirmCodeMutation();
  const loading = useLoading([
    confirmCodeTuple
  ]);

  return {
    loading,
    mutations: {
      confirmCode
    }
  };
}



function __useConfirmCodeMutation() {
  const [fnQuery, confirmCodeQueryTuple] = useConfirmCodeActivityLazyQuery();
  const [tuple, setTuple] = React.useState<ITuple>({
    loading: false
  });
  const [saveSiteUser, saveSiteUserTuple] = useConfirmCodeActivity_SaveSiteUserMutation();
  const loading = useLoading([confirmCodeQueryTuple, tuple, saveSiteUserTuple]);


  async function fnWrappedMutate(email: string, code: string) {
    try {
      setTuple({ loading: true });
      await authService.confirmRegisterCode(email, code);
      await authService.signInWithRegisteredPassword(email);
      const res = await fnQuery({});
      if (res.data?.loggedInUser?.id) {
        await saveSiteUser({
          variables: {
            id: res.data.loggedInUser.id,
            firstName: localStorage.getItem('firstName') ?? '',
            lastName: localStorage.getItem('lastName') ?? ''
          }
        });
      }
    } finally {
      setTuple({ loading: false });
    }
  }

  return [
    fnWrappedMutate,
    {
      ...tuple,
      loading
    }
  ] as const;
}
